var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { cloneElement, memo } from "react";
import { Box, OverflowingTypography, Stack, } from "../components";
const isWithoutChildren = (input) => {
    return "title" in input;
};
export const MemoizedField = memo((_a) => {
    var { typographyProps, disable, sx } = _a, props = __rest(_a, ["typographyProps", "disable", "sx"]);
    if (isWithoutChildren(props)) {
        return (React.createElement(Stack, { sx: sx, width: "100%" },
            React.createElement(OverflowingTypography, Object.assign({ variant: "body3", fontWeight: "semibold" }, typographyProps, { sx: Object.assign({ opacity: disable ? 0.5 : 1, pointerEvents: disable ? "none" : undefined }, typographyProps === null || typographyProps === void 0 ? void 0 : typographyProps.sx) }), props.title),
            props.subTitle && (React.createElement(OverflowingTypography, Object.assign({ variant: "body3" }, typographyProps, { sx: Object.assign({ opacity: disable ? 0.5 : 1, pointerEvents: disable ? "none" : undefined, color: (theme) => theme.palette.disabled.onContainer }, typographyProps === null || typographyProps === void 0 ? void 0 : typographyProps.sx) }), props.subTitle))));
    }
    return (React.createElement(Box, { width: "100%", sx: Object.assign({ display: "flex", alignItems: "center", justifyContent: "center", opacity: disable ? 0.5 : 1, pointerEvents: disable ? "none" : undefined }, sx) }, disable
        ? cloneElement(props.children, { disabled: true })
        : props.children));
});
//# sourceMappingURL=MemoizedField.js.map